module.exports = __webpack_public_path__ + "img/logo.554fa950.png";